import { WidgetSettings } from "assets/icons/Common";
import { Col, Row } from "components/primitives";
import { DashboardContext } from "contexts/DashboardContext";
import { useContext, useEffect } from "react";
import styled from "styled-components";
import { WidgetFC } from "types/Widget";
import { getDateString, getFullDateString } from "util/getDateString";

import { DefaultSchedule } from ".";
import { CalendarDateFormats } from "../Calendar/CalendarDateFormats";
import { ScheduleItemData } from "./interfaces";
import { ScheduleItem } from "./ScheduleItem";

export interface SchedulerState {
  completed: CompletedMap;
}

type CompletedMap = { [id: string]: boolean };

export const Scheduler: WidgetFC<SchedulerState> = ({
  state: { completed = {} } = {},
  setState,
  setSetting,
  onOpenSettings,
}) => {
  const {
    data: { assignedSchedules },
  } = useContext(DashboardContext);

  const schedule = assignedSchedules?.[getFullDateString(new Date())]?.schedule || [];

  const updateCompleted = (id: string, isCompleted: boolean) => {
    let newCompleted = { ...completed };
    newCompleted[id] = isCompleted;
    setState({ completed: newCompleted });
  };

  return (
    <OuterContainer>
      <HeaderContainer>
        <p>{CalendarDateFormats["Tuesday, 24 April 2023"](new Date())}</p>
      </HeaderContainer>
      {schedule?.length > 0 && (
        <ScheduleContainer>
          {schedule.map((scheduleItem: ScheduleItemData, index: number) => (
            <ScheduleItem
              key={index}
              {...scheduleItem}
              isComplete={completed[scheduleItem.id] || false}
              setIsCompleted={updateCompleted}
            />
          ))}
        </ScheduleContainer>
      )}
      {schedule?.length === 0 && (
        <NoContentContainer>
          Open
          <TextBtn onClick={onOpenSettings}>
            <WidgetSettings width={"1em"} height={"1em"} /> <b>Settings</b>
          </TextBtn>
          to add an activity
        </NoContentContainer>
      )}
    </OuterContainer>
  );
};

const OuterContainer = styled.div`
  width: 100%;
  height: 100%;
`;

const HeaderContainer = styled(Col)`
  width: 100%;
  height: 20cqw;
  border-bottom: 1px solid #dde1e8;
  justify-content: center;
  align-items: center;
  padding: 3cqw;

  p {
    color: var(--widget-primary);
    font-weight: 600;
    font-size: 5cqw;
  }
`;

const ScheduleContainer = styled(Col)`
  gap: 1cqw;
  padding: 3cqw;
  overflow: auto;
  height: calc(100% - 20cqw);
`;

const NoContentContainer = styled(Row)`
  justify-content: center;
  margin-top: 30cqw;
  align-items: flex-end;
  width: 100%;
  font-size: 5cqw;
`;

const TextBtn = styled.button`
  border: none;
  box-shadow: none;
  background-color: transparent;
  display: flex;
  color: var(--widget-primary);
  align-items: center;
  padding: 0 5px;
  gap: 5px;
`;
